export default __webpack_public_path__ + "static/media/app-bg-03.b16f4e17.png";